module.exports = __webpack_public_path__ + "img/Albania.d74bb9ef.svg";